import { length, sum } from "ramda";
import { buildFieldSelect, getAndSanitizeInternalName, isExpandField, isExpandLookupKindField } from "./list.rest.helpers";

const MAX_EXPAND_LOOKUP_COUNT = 12;

function* partitionSelectAndExpandInner(queryFields, maxLength) {
    let select = '';
    let expand = '';
    let expandLookupCount = 0;

    for (const field of queryFields) {
        const isExpand = isExpandField(field);
        const fieldSelect = buildFieldSelect(field);
        const fieldSanitized = getAndSanitizeInternalName(field);
        const thisFieldLookupCount = isExpandLookupKindField(field) ? 1 : 0;

        const fullFieldSelect = select ? ',' + fieldSelect : '&$select=' + fieldSelect;
        const fullFieldExpand = isExpand ? (expand ? ',' + fieldSanitized : '&$expand=' + fieldSanitized) : '';

        const nextLength = sum([select, expand, fullFieldSelect, fullFieldExpand].map(length));
        const nextExpandLookupCount = expandLookupCount + thisFieldLookupCount;

        if (nextLength > maxLength || nextExpandLookupCount > MAX_EXPAND_LOOKUP_COUNT) {
            if (!select) {
                throw new Error('Could not partition REST items URL. maxLength is too small.');
            }

            yield {
                select,
                expand,
            }

            // Start new $select and $expand with the current field
            select = '&$select=' + fieldSelect;
            expand = isExpand ? '&$expand=' + fieldSanitized : '';
            expandLookupCount = thisFieldLookupCount;
        } else {
            select += fullFieldSelect;
            expand += fullFieldExpand;
            expandLookupCount += thisFieldLookupCount;
        }
    }

    if (select) {
        yield {
            select,
            expand,
        }
    }
}

export const partitionSelectAndExpand = (queryFields, maxLength) =>
    Array.from(partitionSelectAndExpandInner(queryFields, maxLength));